/** =========================================================
 * Customer employeess controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-customer-employees')
    .controller('CustomerEmployeesController', CustomerEmployeesController);

  CustomerEmployeesController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function CustomerEmployeesController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page customer employees',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'customer_employee',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [{
            customer: ['id', 'name']
          }],
          count: ['projects']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['customer'],
        fields: [{
          title: 'Name',
          key: 'name',
          order: true
        }, {
          title: 'Phone',
          key: 'phone',
          order: true
        }, {
          title: 'Email',
          key: 'email',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-customer-employee.html',
          item: $stateParams.filters.length !== 0 ? {
            customer_id: $stateParams.filters[0].value[2]
          } : {}
        },
        edit: {
          template: 'app/views/dialogs/item-customer-employee.html',
          except: ['customer', 'projects_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Projects',
          icon: 'icon-folder-alt',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('Customer employee') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['customer_employee_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projects_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }, {
          title: 'Customer',
          icon: 'icon-briefcase',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('customer view'),
          action: function (item) {
            try {
              $state.go('app.page-customers', {
                filters: [{
                  name: $translate.instant('Customer employee') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['id', '=', item.customer_id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
